import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';

export default class Product extends Default {}

ControllerPage._addPage('product', Product);
